import { createFileRoute } from '@tanstack/react-router';

import { bankAccountPixKeysScreen, loadBankAccountMessages, loadBankAccountScreens } from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

// Gerenciar chaves Pix (`router.tsx:475-483`): tela filha do detalhe, fora da barra de abas.
export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves')({
  staticData: { screen: bankAccountPixKeysScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountPixKeysScreen'),
});
